module.exports = __webpack_public_path__ + "images/58c9341c4f5948ff63ccc1f5e5bc7feb.png";